'use client';

import { useCallback, useState } from 'react';
import { isFunction } from 'lodash';

import { Button, Icon } from '@repo/ui';
import DocumentLibraryModal from './DocumentLibraryModal';

interface BARColumnProps {
  invoiceId: string;
  onListenOpenEvent?: (isOpen: boolean) => void;
}

export default function BARColumn({ invoiceId, onListenOpenEvent }: Readonly<BARColumnProps>) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenEvent = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();
      setIsOpen(true);
      if (isFunction(onListenOpenEvent)) {
        onListenOpenEvent?.(true);
      }
    },
    [onListenOpenEvent]
  );

  const handleCloseEvent = useCallback(() => {
    setIsOpen(false);
    if (isFunction(onListenOpenEvent)) {
      onListenOpenEvent(false);
    }
  }, [onListenOpenEvent]);

  return (
    <>
      <button type="button" onClick={event => event.stopPropagation()}>
        <Button
          variant="ghost"
          onClick={handleOpenEvent}
          className="focus:outline-none focus:ring-0"
        >
          <Icon
            name="HiDocumentReport"
            size="md"
            className="text-xtnd-dark hover:text-xtnd-blue dark:text-xtnd-white"
          />
        </Button>
        <DocumentLibraryModal isOpen={isOpen} onClose={handleCloseEvent} invoiceId={invoiceId} />
      </button>
    </>
  );
}
